import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import { useModalForm } from 'assets/components/form/modalForm/ModalForm';
import SearchInput from 'assets/components/inputs/search/SearchInput';
import Pagination from 'assets/components/pagination/Pagination';
import ThemePaginationRounded from 'assets/components/pagination/themes/Theme.Pagination.Rounded';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import useApi from 'assets/hooks/api/useApi';
import { getLocales } from 'assets/locales/Locale';
import { defaultLimit, defaultOffset } from 'config/Api.Config';
import { compact } from 'lodash';
import LossCode from 'models/claims/lossCode/Model.LossCode';
import { useState } from 'react';

export default function ClaimTypeEditLossCodes() {
  const { lang } = getLocales();
  const { form } = useModalForm<Api.Core.ClaimType.Save.IRequest>();
  const [showSelectedPermissionsOnly, setShowSelectedPermissionsOnly] = useState(false);
  const [{ limit, offset }, setLimits] = useState({ limit: defaultLimit, offset: defaultOffset });
  const {
    payload: lossCodePayload,
    execute: reloadLossCodes,
    body: LossCodeReq,
    isExecuting,
  } = useApi({
    action: LossCode.list,
  });

  const lossCodeList = compact(
    showSelectedPermissionsOnly
      ? lossCodePayload?.data?.filter((lossCode) => form.data.lossCodes?.find((it) => it.id === lossCode.id))
      : lossCodePayload?.data
  ).slice(offset * limit, offset * limit + limit);

  const areAllSelected = lossCodePayload?.data?.every((d) => form.data.lossCodes?.some((l) => l.id === d.id));
  const areNoneSelected = !lossCodePayload?.data?.some((d) => form.data.lossCodes?.some((l) => l.id === d.id));
  return (
    <>
      <table className={ThemeTableSimple}>
        <thead>
          <tr>
            <th>
              <Button
                class={{ button: ThemeButtonCircle }}
                media="fas-tasks"
                onClick={() => setShowSelectedPermissionsOnly((it) => !it)}
                isLoading={isExecuting}
                active={showSelectedPermissionsOnly}
                htmlElementProps={{ title: lang.showOnlySelected }}
              />
            </th>
            <th colSpan={4}>
              <SearchInput
                value={LossCodeReq?.search}
                onSearch={(search) => reloadLossCodes((body) => ({ ...body, search }))}
                threshold={2}
                placeholder={`${lang.search}...`}
              />
            </th>
          </tr>
          <tr>
            <th>
              <Button
                class={{ button: ThemeButtonCircle }}
                media={areAllSelected ? 'fas-check-square' : areNoneSelected ? 'far-square' : 'fas-minus-square'}
                disabled={!lossCodePayload?.count}
                onClick={() => {
                  form.update({ lossCodes: areAllSelected ? [] : lossCodePayload?.data?.map(({ id }) => ({ id })) });
                }}
                htmlElementProps={{ title: lang.selectAll }}
              />
            </th>
            <th>{lang.code}</th>
            <th>{lang.descnEn}</th>
            <th>{lang.notes}</th>
            <th>{lang.category}</th>
          </tr>
        </thead>
        <tbody>
          <DataMap
            data={lossCodeList}
            render={({ data: lossCode }) => {
              const currentLossCode = form.data.lossCodes?.find((it) => it.id === lossCode.id);

              return (
                <tr key={lossCode.id}>
                  <td>
                    <Button
                      class={{ button: ThemeButtonCircle }}
                      htmlElementProps={{
                        title: currentLossCode ? lang.unselect : lang.select,
                      }}
                      onClick={() => {
                        if (currentLossCode)
                          form.update({ lossCodes: form.data.lossCodes?.filter((it) => it?.id !== lossCode.id) });
                        else form.update({ lossCodes: [...(form.data.lossCodes || []), { id: lossCode.id }] });
                      }}
                      media={currentLossCode ? 'fas-check-square' : 'far-square'}
                    />
                  </td>
                  <td>{lossCode.code}</td>
                  <td>{lossCode.descnEn}</td>
                  <td>{lossCode.notes}</td>
                  <td>{lossCode.category}</td>
                </tr>
              );
            }}
          />
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={5}>
              <Pagination
                class={ThemePaginationRounded}
                count={lossCodePayload?.count}
                offset={offset}
                limit={limit}
                onLimitChange={(limit) => setLimits({ limit, offset: 0 })}
                onOffsetChange={(offset) => setLimits((old) => ({ ...old, offset }))}
              />
            </td>
          </tr>
        </tfoot>
      </table>
    </>
  );
}
